import { useSelector } from 'hooks/utils';
import { selectValidationErrors } from 'store/data/entries';

export function useGetValidationErrors() {
	return useSelector(state => selectValidationErrors(state.data.entries));
}
